import * as React from "react";

import { IDLE_TIMEOUT_MS, VERIFY_ACTIVE_INTERVAL } from 'src/config';
import { SessionContext } from 'src/Views/SessionContext';
import { tellServerUserInteractionHasOccurred } from 'src/Views/sessionService';
import SessionExpiredDialog from 'src/Views/SessionExpiryDialog';

interface IState {}
interface IProps {}

class SessionManager extends React.Component<IProps, IState> {
    public static contextType = SessionContext;
    public context!: React.ContextType<typeof SessionContext>;
    private verifyInterval: NodeJS.Timeout | null;
    private lastActivityTime: number;

    constructor(props: IProps) {
        super(props);
        this.verifyInterval = null;
        this.lastActivityTime = Date.now();
        this.recordActivity = this.recordActivity.bind(this);
        this.extendSession = this.extendSession.bind(this);
        this.closeSession = this.closeSession.bind(this);
        this.userInteractionServerCallSuccess = this.userInteractionServerCallSuccess.bind(this);
        this.tellServerAboutSession = this.tellServerAboutSession.bind(this);
    }

    public componentDidMount() {
        this.verifyInterval = setInterval(this.tellServerAboutSession, VERIFY_ACTIVE_INTERVAL);
        document.addEventListener('mousemove', this.recordActivity);
        document.addEventListener('mousedown', this.recordActivity);
        document.addEventListener('keydown', this.recordActivity);
        document.addEventListener('touchstart', this.recordActivity);
    }

    public componentWillUnmount() {
        if (this.verifyInterval) {
            clearInterval(this.verifyInterval);
        }
        document.removeEventListener('mousemove', this.recordActivity);
        document.removeEventListener('mousedown', this.recordActivity);
        document.removeEventListener('keydown', this.recordActivity);
        document.removeEventListener('touchstart', this.recordActivity);
    }

    public render() {
        if (this.context.state.showExpiryDialog) {
            return <SessionExpiredDialog
                onExtendSession={this.extendSession}
                onEndSession={this.closeSession}
            />;
        }
        return <span />;
    }

    private recordActivity() {
        this.lastActivityTime = Date.now();
    }

    private userInteractionServerCallSuccess(newJWT: string) {
        this.context.dispatch({ type: "setWebToken", payload: newJWT });
        if (this.context.state.showExpiryDialog) {
            this.context.dispatch({ type: "setShowExpiryDialog", payload: false });
        }
    }

    private closeSession() {
        this.context.dispatch({ type: "clearLoggedInUser", payload: undefined });
        this.context.dispatch({ type: "clearWebToken", payload: undefined });
        this.context.dispatch({ type: "setShowExpiryDialog", payload: false });
    }

    private extendSession() {
        this.lastActivityTime = Date.now();
        this.context.dispatch({ type: "setShowExpiryDialog", payload: false });
        if (this.context.state.webToken) {
            tellServerUserInteractionHasOccurred(
                this.context.state.webToken,
                this.userInteractionServerCallSuccess,
                this.closeSession
            );
        }
    }

    private tellServerAboutSession() {
        if (!this.context.state.webToken) {
            return;
        }
        const isIdle = Date.now() - this.lastActivityTime >= IDLE_TIMEOUT_MS;
        if (isIdle) {
            if (!this.context.state.showExpiryDialog) {
                this.context.dispatch({ type: "setShowExpiryDialog", payload: true });
            }
        } else {
            tellServerUserInteractionHasOccurred(
                this.context.state.webToken,
                this.userInteractionServerCallSuccess,
                this.closeSession
            );
        }
    }
}

export default SessionManager;
